<template>
  <employee-profile>
    <modal-dialog-prevent-leave
      v-bind:is-shown="isShownDialogLeaveConfirm"
      v-on:back="isShownDialogLeaveConfirm = false"
      v-on:leave="leaveWithoutSave"
      v-on:save="saveAndLeave" />
    <form
      class="employee-payroll-schema__form"
      v-on:keyup.enter="onSubmit"
      v-on:submit.prevent="onSubmit"
    >
      <template v-if="hasFetchedAdminSettings">
        <div class="employee-payroll-schema__fieldset" role="group">
          <div class="employee-payroll-schema__fieldset__title">Оклад</div>
          <div class="employee-payroll-schema__fieldset__row">
            <div class="employee-payroll-schema__fieldset__group">
              <span class="employee-payroll-schema__fieldset__label">Тип ставки:</span>
              <input-radio
                identifier="rate-type"
                v-bind:items="adminSalaryTypes"
                v-model="selectedAdminSalaryType"
                v-on:input="checkChanges" />
            </div>
            <div class="employee-payroll-schema__fieldset__group">
              <span class="employee-payroll-schema__fieldset__label">Сумма (₽):</span>
              <input-number
                min="0"
                title=""
                v-model="adminHourlyRate"
                v-on:input="checkChanges"
                without-native-controls />
            </div>
          </div>
        </div>
        <button
          v-bind:disabled="isAwaitAdminPayrollSettingsSave"
          class="employee-payroll-schema__submit"
          type="submit"
        >Сохранить</button>
      </template>
      <template v-else-if="hasFetchedDoctorSettings">
        <div class="employee-payroll-schema__fieldset" role="group">
          <div class="employee-payroll-schema__fieldset__title">Оклад</div>
          <div class="employee-payroll-schema__fieldset__row">
            <div class="employee-payroll-schema__fieldset__group">
              <span class="employee-payroll-schema__fieldset__label">Тип ставки:</span>
              <input-radio
                identifier="rate-type"
                v-bind:items="doctorSalaryTypes"
                v-model="selectedDoctorSalaryType"
                v-on:input="checkChanges"
              />
            </div>
            <div class="employee-payroll-schema__fieldset__group">
              <span class="employee-payroll-schema__fieldset__label">Сумма (₽):</span>
              <input-number
                min="0"
                title=""
                v-model="doctorSalaryRateRoubles"
                v-on:input="checkChanges"
                without-native-controls />
            </div>
          </div>
        </div>
        <div class="employee-payroll-schema__fieldset" role="group">
          <div class="employee-payroll-schema__fieldset__title">Сдельная часть</div>
          <div class="employee-payroll-schema__fieldset__group group-column">
            <span class="group-column__switch-wrapper">
              <v-switch
                v-model="doctorPieceworkWithComplaint"
              />
              Учитывать услуги по рекламации
            </span>
            <span class="group-column__switch-wrapper">
              <v-switch
                v-model="doctorPieceworkWithoutDiscounts"
              />
              Считать без учета скидок
            </span>
            <span class="group-column__switch-wrapper">
              <v-select
                item-text="name"
                item-value="id"
                v-bind:items="priceLists"
                v-model="selectedPriceListId"
              />
              Выберите прайс
            </span>
          </div>
          <div class="employee-payroll-schema__exclusion-wrapper">
            <div class="employee-payroll-schema__exclusion payroll-table-head">
              <span class="payroll-table-head__title">Наименование услуги</span>
              <span class="payroll-table-head__title payroll-table-head__title--info">Процент от стоимости услуги, %
                <help-icon v-bind:tooltip-text="$options.helpTextServicePercent" />
              </span>
              <span class="payroll-table-head__title">Фиксированная сумма, ₽</span>
            </div>
            <div v-bind:key="doctorExclusionsTableKey">
              <div
                v-bind:key="row.categoryId"
                v-for="row in doctorPieceworkCategoryRows">
                <div class="employee-payroll-schema__exclusion">
                  <button
                    class="employee-payroll-schema__category__cell"
                    type="button"
                    v-bind:title="`Перейти к исключениям ${row.title}`"
                    v-on:click="(evt) => onSelectExclusionCategory(evt, row.title)"
                  >{{ row.title }}</button>
                  <input-number
                    v-bind:ref="`${row.key}-input-percentage`"
                    max="100"
                    min="0"
                    title=""
                    class="employee-payroll-schema__input"
                    v-bind:value="row.percentage"
                    v-on:input="onInputDoctorExclusionCategoryPercentage(row.categoryId, $event)"
                    v-on:focus="setFocusedInput(`${row.key}-input-percentage`)"
                    without-native-controls />
                  <input-number
                    v-bind:ref="`${row.key}-input-fixed`"
                    min="0"
                    title=""
                    class="employee-payroll-schema__input"
                    v-bind:value="row.fixed"
                    v-on:input="onInputDoctorExclusionCategoryFixed(row.categoryId, $event)"
                    v-on:focus="setFocusedInput(`${row.key}-input-fixed`)"
                    without-native-controls />
                </div>
                <div
                  v-if="row.selected"
                >
                  <div
                    class="employee-payroll-schema__exclusion"
                    v-bind:class="subrow.rowClasses"
                    v-bind:key="subrow.key"
                    v-for="subrow in doctorPieceworkExclusionRows">
                    <button
                      class="employee-payroll-schema__category__cell cell-child"
                      type="button"
                      v-bind:title="`Перейти к исключениям ${subrow.title}`"
                    >{{ subrow.title }}</button>
                    <input-number
                      v-bind:ref="`${subrow.key}-input-percentage`"
                      max="100"
                      min="0"
                      title=""
                      class="employee-payroll-schema__input"
                      v-bind:value="subrow.percentage"
                      v-on:focus="setFocusedInput(`${subrow.key}-input-percentage`)"
                      v-on:input="onInputDoctorExclusionServicePercentage(
                        subrow.categoryId,
                        subrow.value,
                        $event,
                      )"
                      without-native-controls />
                    <input-number
                      v-bind:ref="`${subrow.key}-input-fixed`"
                      min="0"
                      title=""
                      class="employee-payroll-schema__input"
                      v-bind:value="subrow.fixed"
                      v-on:focus="setFocusedInput(`${subrow.key}-input-fixed`)"
                      v-on:input="onInputDoctorExclusionServiceFixed(
                        subrow.categoryId,
                        subrow.value,
                        $event,
                      )"
                      without-native-controls />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          v-bind:disabled="isAwaitDoctorPayrollSettingsSave"
          class="employee-payroll-schema__submit"
          type="submit"
        >Сохранить</button>
      </template>
      <template v-else-if="hasFetchedAssistantSettings">
        <div class="employee-payroll-schema__fieldset" role="group">
          <div class="employee-payroll-schema__fieldset__title">Оклад</div>
          <div class="employee-payroll-schema__fieldset__row">
            <div class="employee-payroll-schema__fieldset__group">
              <span class="employee-payroll-schema__fieldset__label">Тип ставки:</span>
              <input-radio
                identifier="rate-type"
                v-bind:items="assistantSalaryTypes"
                v-model="selectedAssistantSalaryType"
                v-on:input="checkChanges"
              />
            </div>
            <div class="employee-payroll-schema__fieldset__group">
              <span class="employee-payroll-schema__fieldset__label">Сумма (₽):</span>
              <input-number
                min="0"
                title=""
                v-model="assistantSalaryRateRoubles"
                v-on:input="checkChanges"
                without-native-controls
              />
            </div>
          </div>
          <div
            v-if="assistantShowPiecework"
            class="employee-payroll-schema__fieldset__title"
          >
            Укажите ставку в зависимости от специализации врача
            <help-icon v-bind:tooltip-text="$options.helpTextSalary" />
          </div>
          <div v-if="assistantShowPiecework">
            <div
              v-for="(salary, index) in assistantSalariesByAssistingDoctors"
              v-bind:key="`salary-by-doctor-${index}}`"
              class="employee-payroll-schema__fieldset__row"
            >
              <div class="employee-payroll-schema__fieldset__group-stake-doctor stake-doctor">
                <v-autocomplete
                  attach
                  clearable
                  label="Врач"
                  item-text="name"
                  item-value="doctor_id"
                  v-bind:items="assistantDoctorsToAssisting"
                  v-model="salary.doctor_id">
                  <template v-slot:item="{ item }">
                    <item-employee v-bind:name="item.name" v-bind:positions="item.speciality" />
                  </template>
                </v-autocomplete>
                <div class="employee-payroll-schema__fieldset__group stake-doctor__group-input">
                  <span class="employee-payroll-schema__fieldset__label">Сумма (₽):</span>
                  <input-number
                    min="0"
                    title=""
                    v-model="salary.value"
                    v-on:input="checkChanges"
                    without-native-controls
                  />
                </div>
                <button
                  v-if="index === 0"
                  title="Добавить"
                  type="button"
                  class="employee-payroll-schema__fieldset__button-add"
                  v-bind:disabled="hasDoctorToAssisting"
                  v-on:click="onAddAssistingDoctor()"
                >+</button>
                <button
                  v-else
                  title="Удалить"
                  type="button"
                  class="employee-payroll-schema__fieldset__button-remove"
                  v-on:click="onRemoveAssistingDoctor(index)"
                >-</button>
              </div>
            </div>
            <div class="employee-payroll-schema__fieldset__select-price-list">
              <span class="employee-payroll-schema__fieldset__label">Выберите прайс</span>
              <v-select
                item-text="name"
                item-value="id"
                v-bind:items="priceLists"
                v-model="selectedPriceListId"
              />
            </div>
          </div>
        </div>
        <div
          v-if="assistantShowPiecework"
          class="employee-payroll-schema__fieldset"
          role="group"
        >
          <div class="employee-payroll-schema__fieldset__title">Сдельная часть</div>
          <div class="employee-payroll-schema__exclusion-wrapper">
            <div class="employee-payroll-schema__exclusion payroll-table-head">
              <span class="payroll-table-head__title">Наименование услуги</span>
              <span class="payroll-table-head__title payroll-table-head__title--info">Процент от стоимости услуги, %
                <help-icon v-bind:tooltip-text="$options.helpTextServicePercent" />
              </span>
              <span class="payroll-table-head__title">Фиксированная сумма, ₽</span>
            </div>
            <div
              v-bind:key="assistantExclusionsTableKey"
            >
              <div
                v-bind:key="row.categoryId"
                v-for="row in assistantPieceworkCategoryRows">
                <div class="employee-payroll-schema__exclusion">
                  <button
                    class="employee-payroll-schema__category__cell"
                    type="button"
                    v-bind:title="`Перейти к исключениям ${row.title}`"
                    v-on:click="(evt) => onSelectAssistantExclusionCategory(evt, row.title)"
                  >{{ row.title }}</button>
                  <input-number
                    v-bind:ref="`${row.key}-input-percentage`"
                    max="100"
                    min="0"
                    title=""
                    class="employee-payroll-schema__input"
                    v-bind:value="row.percentage"
                    v-on:focus="`${row.key}-input-percentage`"
                    v-on:input="onInputAssistantExclusionCategoryPercentage(row.categoryId, $event)"
                    without-native-controls />
                  <input-number
                    v-bind:ref="`${row.key}-input-fixed`"
                    min="0"
                    title=""
                    class="employee-payroll-schema__input"
                    v-bind:value="row.fixed"
                    v-on:focus="`${row.key}-input-fixed`"
                    v-on:input="onInputAssistantExclusionCategoryFixed(row.categoryId, $event)"
                    without-native-controls />
                </div>
                <div
                  v-if="row.selected"
                >
                  <div
                    class="employee-payroll-schema__exclusion"
                    v-bind:class="subrow.rowClasses"
                    v-bind:key="subrow.key"
                    v-for="subrow in assistantPieceworkExclusionRows">
                    <button
                      class="employee-payroll-schema__category__cell cell-child"
                      type="button"
                      v-bind:title="`Перейти к исключениям ${subrow.title}`"
                    >{{ subrow.title }}</button>
                    <input-number
                      v-bind:ref="`${subrow.key}-input-percentage`"
                      max="100"
                      min="0"
                      title=""
                      class="employee-payroll-schema__input"
                      v-bind:value="subrow.percentage"
                      v-on:focus="`${subrow.key}-input-percentage`"
                      v-on:input="onInputAssistantExclusionServicePercentage(
                        subrow.categoryId,
                        subrow.value,
                        $event,
                      )"
                      without-native-controls />
                    <input-number
                      v-bind:ref="`${subrow.key}-input-fixed`"
                      min="0"
                      title=""
                      class="employee-payroll-schema__input"
                      v-bind:value="subrow.fixed"
                      v-on:focus="`${subrow.key}-input-fixed`"
                      v-on:input="onInputAssistantExclusionServiceFixed(
                        subrow.categoryId,
                        subrow.value,
                        $event,
                      )"
                      without-native-controls />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          v-bind:disabled="isAwaitAssistantPayrollSettingsSave"
          class="employee-payroll-schema__submit"
          type="submit"
        >Сохранить</button>
      </template>
    </form>
  </employee-profile>
</template>
<script>
import InputNumber from '@/components/InputNumber.vue';
import InputRadio from '@/components/InputRadio.vue';
import notifierMixin from '@/mixins/notifierMixin';
import EmployeeProfile from '@/views/ClinicPanel/EmployeeProfile.vue';
import { AdminPayrollSettings, AssistantPayrollSettings, DoctorPayrollSettings } from '@/storage/gateways/PayrollGateway';
import debounce from 'lodash.debounce';
import ModalDialogPreventLeave from '@/components/ModalDialogPreventLeave.vue';
import preventLeaveWithoutConfirmMixin from '@/mixins/preventLeaveWithoutConfirmMixin';
import HelpIcon from '@/components/HelpIcon.vue';
import ItemEmployee from '@/components/ItemEmployee.vue';

const makeDoctorExclusion = (isAssignedManually, percentage, value, categoryId, fixed) => ({
  isAssignedManually,
  percentage,
  value,
  categoryId,
  fixed,
});

const makeExclusion = (isAssignedManually, percentage, value, categoryId, fixed) => ({
  isAssignedManually,
  percentage,
  value,
  categoryId,
  fixed,
});

const makeSelectedCategory = (value, percentage, fixed) => ({
  value,
  percentage,
  fixed,
});

const makeMakeExclusionRow = (index, title, value) => {
  const key = `piecework-exclusion-services:${value}`;
  const number = index + 1;
  return (checked, isAssignedManually, percentage, fixed, categoryId) => ({
    rowClasses: isAssignedManually ? ['assigned-manually'] : [],
    checked,
    key,
    number,
    percentage,
    title,
    value,
    fixed,
    categoryId,
  });
};

/**
 * @description Текст кнопки помощи - "Укажите ставку в зависимости от специализации врача".
 * @type {string}
 */
const helpTextSalary = 'Для корректного начисления ЗП укажите ассистента в графике работы врача.'
  + ' Добавьте нужного врача в Учет времени ассистента';

/**
 * @description Текст кнопки помощи - "Процент от стоимости услуги".
 * @type {string}
 */
const helpTextServicePercent = 'Вы можете указать общий процент для целой категории услуг или для каждой услуги отдельно.';

const adminSettingsMixin = {
  data() {
    return {
      isAwaitAdminPayrollSettingsSave: false,
      initialAdminSettings: new AdminPayrollSettings(),
      adminName: '',
      adminHourlyRate: '0',
      adminRole: '',
      adminSalaryTypes: [],
      selectedAdminSalaryType: '',
    };
  },
  methods: {
    /**
     * @description Получить настройки расчета администратора.
     * @param {string} employeeId Идентификатор сотрудника.
     * @returns {Promise}
     */
    fetchAdminSettings(employeeId) {
      return this
        .$payrollGateway
        .viewAdminPayrollSettings(employeeId)
        .then((result) => {
          result.forEach(({
            employee_name: adminName,
            employee_role: adminRole,
            hourly_rate_roubles: adminHourlyRate,
            salary_types: adminSalaryTypes,
          }) => {
            this.adminName = adminName;
            this.adminHourlyRate = adminHourlyRate;
            this.adminRole = adminRole;
            this.adminSalaryTypes = adminSalaryTypes;
          });
          return result.isLeft() ? Promise.reject() : Promise.resolve();
        });
    },
    /**
     * @description Получить прайс-листы.
     * @returns {void}
     */
    fetchPriceLists() {
      return this
        .$serviceGateway
        .getPriceLists()
        .then((result) => {
          this.priceLists = result.value.data;
          this.selectedPriceListId = this.priceLists[0]?.id;
        });
    },
    /**
     * @description Проверить наличие изменений настроек администратора.
     * @return {boolean}
     */
    checkAdminChanges() {
      const actualSettings = this.makeAdminSettings();
      return actualSettings.toString() !== this.initialAdminSettings.initial;
    },
    /**
     * @description Создать экземпляр настроек администратора.
     * @return {AdminPayrollSettings}
     */
    makeAdminSettings() {
      return new AdminPayrollSettings(
        this.adminName,
        this.adminHourlyRate,
        this.adminRole,
        this.selectedAdminSalaryType,
      );
    },
    /**
     * @description Проинициализировать данные настроек администратора.
     * @returns {void}
     */
    initAdminData() {
      this.selectedAdminSalaryType = this
        .adminSalaryTypes
        .flatMap(({ checked, value }) => (checked ? [value] : []))
        .at(0);
      this.initialAdminSettings = this.makeAdminSettings();
    },
    /**
     * @description Обработать изменение настроек расчета.
     * @param {string} employeeId Идентификатор сотрудника.
     * @returns {Promise}
     */
    submitAdminPayrollSettings(employeeId) {
      this.isAwaitAdminPayrollSettingsSave = true;
      const response = this
        .$payrollGateway
        .editAdminPayrollSettings(employeeId, this.adminHourlyRate);
      response
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.isChanged = false;
            this.initialAdminSettings = this.makeAdminSettings();
          });
        })
        .finally(() => { this.isAwaitAdminPayrollSettingsSave = false; });
      return response;
    },
  },
  mixins: [notifierMixin],
};

const assistantSettingsMixin = {
  computed: {
    assistantExclusionsTableKey() {
      return `assistant-exclusions-table:${
        this.assistantExclusionsTableUpdateKey
      }`;
    },
    assistantPieceworkCategoryRows() {
      return this.assistantServicesByPriceList.map(({
        title, percentage, fixed, category_id: categoryId,
      }) => {
        const selection = this
          .assistantSelectedCategory
          .find((item) => categoryId === item.value);
        if (selection) {
          return {
            key: `piecework-exclusion-categories:${title}`,
            selected: this.selectedAssistantExclusionCategory === title,
            title,
            percentage: selection.percentage,
            fixed: selection.fixed,
            categoryId,
          };
        }
        return {
          key: `piecework-exclusion-categories:${title}`,
          selected: this.selectedAssistantExclusionCategory === title,
          title,
          percentage,
          fixed,
          categoryId,
        };
      });
    },
    assistantPieceworkExclusionRows() {
      return this
        .assistantServicesByPriceList
        .flatMap(({ services, title }) => {
          if (title === this.selectedAssistantExclusionCategory) {
            return services;
          }
          return [];
        })
        .map((service, index) => {
          const makeRow = makeMakeExclusionRow(index, service.title, service.value);
          const selection = this
            .selectedAssistantExclusions
            .find((item) => service.value === item.value);
          if (selection) {
            return makeRow(
              true,
              selection.isAssignedManually,
              selection.percentage,
              selection.fixed,
              selection.categoryId,
            );
          }
          return makeRow(
            false,
            false,
            0,
            0,
            service.category_id,
          );
        });
    },
    assistantInitiallyCheckedExclusionIds() {
      return this
        .assistantServicesByPriceList
        .flatMap(({ services }) => services)
        .flatMap(({ checked, value }) => (checked ? [value] : []));
    },
    assistantRemovedExclusionServiceIds() {
      return this.assistantInitiallyCheckedExclusionIds.filter(
        (value) => this
          .selectedAssistantExclusions
          .findIndex((item) => value === item.value) === -1,
      );
    },
    assistantRemovedSalariesByAssistingDoctors() {
      return this.assistantInitialDoctorIdsWithSalariesByAssisting.filter(
        (value) => this
          .assistantSalariesByAssistingDoctors
          .findIndex((item) => value === item.doctor_id) === -1,
      );
    },
    assistantShowPiecework() {
      return this.selectedAssistantSalaryType === 'worked-hours' && this.assistantSettingsFetched;
    },
    hasDoctorToAssisting() {
      return this.assistantDoctorsToAssisting.length === 0;
    },
  },
  data() {
    return {
      initialAssistantSettings: new AssistantPayrollSettings(),
      isAwaitAssistantPayrollSettingsSave: false,
      assistantSettingsFetched: false,
      assistantExclusionsTableUpdateKey: 0,
      assistantName: '',
      assistantPieceworkDefaultPercentage: 0,
      assistantRole: '',
      assistantSalaryRateRoubles: 0,
      assistantSalaryTypes: [],
      assistantServicesByPriceList: [],
      selectedAssistantExclusionCategory: '',
      selectedAssistantExclusions: [],
      selectedAssistantSalaryType: '',
      assistantSelectedCategory: [],
      assistantSalariesByAssistingDoctors: [
        {
          name: '',
          doctor_id: null,
          value: 0,
        },
      ],
      assistantInitialDoctorIdsWithSalariesByAssisting: [],
      timerId: null,
      assistantDoctorsToAssisting: [],
    };
  },
  methods: {
    /**
     * @description Добавить исключение для сдельной оплаты.
     * @param {number} percentage
     * @param {number} fixed
     * @param {number} value
     * @param {number} categoryId
     * @returns {void}
     */
    addAssistantSelectedExclusion(value, categoryId, percentage = 0, fixed = 0) {
      const updatedExclusions = this
        .selectedAssistantExclusions
        .filter((item) => value !== item.value);
      if (percentage !== 0 || fixed !== 0) {
        updatedExclusions.push(makeExclusion(false, percentage, value, categoryId, fixed));
      }
      this.selectedAssistantExclusions = updatedExclusions;
      this.checkChanges();
    },
    /**
     * @description Добавить исключение для сдельной оплаты всех услуг категории.
     * @param {number} value
     * @param {number} percentage
     * @param {number} fixed
     */
    addAssistantSelectedExclusionAllServiceCategory(value, percentage = 0, fixed = 0) {
      this
        .assistantServicesByPriceList
        .flatMap(({ services, category_id: categoryId }) => {
          if (categoryId === value) {
            return services;
          }
          return [];
        })
        .forEach((service) => {
          this.addAssistantSelectedExclusion(service.value, value, percentage, fixed);
        });
    },
    /**
     * @description Добавить в выбранные категорию.
     * @param {number} value
     * @param {number} percentage
     * @param {number} fixed
     */
    addAssistantSelectedCategory(value, percentage = 0, fixed = 0) {
      const categories = this
        .assistantSelectedCategory
        .filter((item) => value !== item.value);
      categories.push(makeSelectedCategory(value, percentage, fixed));
      this.assistantSelectedCategory = categories;
    },
    /**
     * @description Проверить наличие изменений настроек ассистента.
     * @return {boolean}
     */
    checkAssistantChanges() {
      const actualSettings = this.makeAssistantSettings();
      return actualSettings.toString() !== this.initialAssistantSettings.initial;
    },
    /**
     * @description Получить настройки расчета ассистента.
     * @param {string} employeeId               Идентификатор сотрудника.
     * @param {string|null} selectedPriceListId Идентификатор прайс-листа.
     * @param {boolean} byDefaultPriceList      Искать по прайс-листу по умолчанию
     * @returns {Promise}
     */
    fetchAssistantSettings(employeeId, selectedPriceListId = null, byDefaultPriceList = false) {
      this.assistantSettingsFetched = false;
      return this
        .$payrollGateway
        .viewAssistantPayrollSettings(employeeId, selectedPriceListId, byDefaultPriceList)
        .then((result) => {
          result.forEach((data) => {
            this.assistantName = data.employee_name;
            this.assistantRole = data.employee_role;
            this.assistantSalaryRateRoubles = data.salary_rate_roubles;
            this.assistantSalaryTypes = data.salary_types;
            this.assistantServicesByPriceList = data.services_by_price_list;
            this.assistantSalariesByAssistingDoctors = data.salaries_by_assisting_doctors.length > 0
              ? data.salaries_by_assisting_doctors
              : [
                {
                  name: '',
                  doctor_id: null,
                  value: 0,
                },
              ];
            this.assistantDoctorsToAssisting = data.doctor_to_assisting_salaries;
            this.assistantSettingsFetched = true;
          });
          return result.isLeft() ? Promise.reject() : Promise.resolve();
        });
    },
    /**
     * @description Форсировать обновление таблицы исключений ассистента.
     * @returns {void}
     */
    forceAssistantExclusionsTableUpdate() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(async () => {
        this.assistantExclusionsTableUpdateKey += 1;
      }, 1500);
    },
    /**
     * @description Проинициализировать данные настроек ассистента.
     * @returns {void}
     */
    initAssistantData() {
      this.selectedAssistantSalaryType = this
        .assistantSalaryTypes
        .flatMap(({ checked, value }) => (checked ? [value] : []))
        .at(0);
      this.selectedAssistantExclusions = this
        .assistantServicesByPriceList
        .flatMap(({ services }) => services)
        .flatMap(({
          checked,
          is_assigned_manually: isAssignedManually,
          percentage,
          value,
          category_id: categoryId,
          fixed,
        }) => {
          if (checked) {
            return [makeExclusion(
              isAssignedManually,
              percentage,
              value,
              categoryId,
              fixed,
            )];
          }
          return [];
        });
      this.assistantSelectedCategory = this
        .assistantServicesByPriceList
        .map(
          ({ category_id: categoryId, fixed, percentage }) => (
            makeSelectedCategory(categoryId, percentage, fixed)
          ),
        );
      this.assistantInitialDoctorIdsWithSalariesByAssisting = this
        .assistantSalariesByAssistingDoctors
        .map((item) => item.doctor_id);
      this.initialAssistantSettings = this.makeAssistantSettings();
    },
    /**
     * @description Создать экземпляр настроек ассистента.
     * @return {AssistantPayrollSettings}
     */
    makeAssistantSettings() {
      return new AssistantPayrollSettings(
        this.assistantName,
        this.assistantRole,
        this.assistantSalaryRateRoubles,
        this.selectedAssistantExclusions,
        this.selectedAssistantSalaryType,
      );
    },
    /**
     * @description Обработать ввод процентов исключения сервиса сдельной оплаты.
     * @param {number} categoryId
     * @param {number} serviceId
     * @param {number} percentage
     * @returns {void}
     */
    onInputAssistantExclusionServicePercentage(categoryId, serviceId, percentage) {
      this.addAssistantSelectedExclusion(serviceId, categoryId, percentage);
      this.selectedAssistantExclusions = this.selectedAssistantExclusions.map((item) => {
        if (serviceId === item.value) {
          return makeExclusion(true, percentage, serviceId, categoryId, 0);
        }
        return item;
      });
      this.checkChanges();
      this.forceAssistantExclusionsTableUpdate();
    },
    /**
     * @description Обработать ввод фиксированной суммы исключения сервиса сдельной оплаты.
     * @param {number} categoryId
     * @param {number} serviceId
     * @param {number} fixed
     * @returns {void}
     */
    onInputAssistantExclusionServiceFixed(categoryId, serviceId, fixed) {
      this.addAssistantSelectedExclusion(serviceId, categoryId, 0, fixed);
      this.selectedAssistantExclusions = this.selectedAssistantExclusions.map((item) => {
        if (serviceId === item.value) {
          return makeExclusion(true, 0, serviceId, categoryId, fixed);
        }
        return item;
      });
      this.checkChanges();
      this.forceAssistantExclusionsTableUpdate();
    },
    /**
     * @description Обработать ввод процентов исключения категории сдельной оплаты.
     * @param {number} categoryId
     * @param {number} percentage
     * @returns {void}
     */
    onInputAssistantExclusionCategoryPercentage(categoryId, percentage) {
      this.addAssistantSelectedCategory(categoryId, percentage);
      this.addAssistantSelectedExclusionAllServiceCategory(categoryId, percentage);
      this.checkChanges();
      this.forceAssistantExclusionsTableUpdate();
    },
    /**
     * @description Обработать ввод фиксированной суммы исключения категории сдельной оплаты.
     * @param {number} categoryId
     * @param {number} fixed
     * @returns {void}
     */
    onInputAssistantExclusionCategoryFixed(categoryId, fixed) {
      this.addAssistantSelectedCategory(categoryId, 0, fixed);
      this.addAssistantSelectedExclusionAllServiceCategory(categoryId, 0, fixed);
      this.checkChanges();
      this.forceAssistantExclusionsTableUpdate();
    },
    /**
     * @description Обработать выбор категории исключений.
     * @param {string} value
     * @returns {void}
     */
    onSelectAssistantExclusionCategory(evt, value) {
      if (this.selectedAssistantExclusionCategory === value) {
        this.selectedAssistantExclusionCategory = '';
        evt.target.classList.remove('active');
      } else {
        this.selectedAssistantExclusionCategory = value;
        evt.target.classList.add('active');
      }
    },
    /**
     * @description Добавить оклад при ассистировании.
     * @return {void}
     */
    onAddAssistingDoctor() {
      this.assistantSalariesByAssistingDoctors.push({
        name: '',
        doctor_id: null,
        value: 0,
      });
    },
    /**
     * @description Удалить оклад при ассистировании.
     * @param {string} index Идентификатор.
     * @return {void}
     *
     */
    onRemoveAssistingDoctor(index) {
      this.assistantSalariesByAssistingDoctors.splice(index, 1);
    },
    /**
     * @description Подготовить ставки ассистента по врачам.
     * @returns {Array}
     */
    prepareAssistantSalariesByAssistingDoctors() {
      return this.assistantSalariesByAssistingDoctors.reduce((acc, doctor) => {
        const selectedDoctor = acc
          .find((currentDoctor) => doctor.doctor_id === currentDoctor.doctor_id);
        if (!selectedDoctor && doctor.doctor_id) {
          acc.push(doctor);
        }
        return acc;
      }, []);
    },
    /**
     * @description Обработать отправку данных ассистента.
     * @param {string} employeeId Идентификатор сотрудника.
     * @returns {Promise}
     */
    submitAssistantPayrollSettings(employeeId) {
      this.isAwaitAssistantPayrollSettingsSave = true;
      const assistingSalaries = this.prepareAssistantSalariesByAssistingDoctors();
      const response = this
        .$payrollGateway
        .editAssistantPayrollSettings(
          employeeId,
          this.selectedAssistantExclusions,
          this.assistantRemovedExclusionServiceIds,
          this.assistantSalaryRateRoubles,
          this.selectedAssistantSalaryType,
          this.assistantSelectedCategory,
          assistingSalaries,
          this.assistantRemovedSalariesByAssistingDoctors,
        );
      response
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.isChanged = false;
            this.initialAssistantSettings = this.makeAssistantSettings();
            this.fetchAssistantSettings(this.employeeId);
          });
        })
        .finally(() => { this.isAwaitAssistantPayrollSettingsSave = false; });
      return response;
    },
  },
  helpTextServicePercent,
  helpTextSalary,
  mixins: [notifierMixin],
};

const doctorSettingsMixin = {
  computed: {
    /**
     * @description Выбран прайс-лист по умолчанию
     * @type {boolean}
     */
    selectedDefaultPriceList() {
      return !this.selectedPriceListId;
    },
    doctorExclusionsTableKey() {
      return `doctor-exclusions-table:${
        this.doctorExclusionsTableUpdateKey
      }`;
    },
    doctorPieceworkCategoryRows() {
      return this.doctorServicesByPriceList.map(({
        title, percentage, fixed, category_id: categoryId,
      }) => {
        const selection = this
          .doctorSelectedCategory
          .find((item) => categoryId === item.value);
        if (selection) {
          return {
            key: `piecework-exclusion-categories:${title}`,
            selected: this.selectedDoctorExclusionCategory === title,
            title,
            percentage: selection.percentage,
            fixed: selection.fixed,
            categoryId,
          };
        }
        return {
          key: `piecework-exclusion-categories:${title}`,
          selected: this.selectedDoctorExclusionCategory === title,
          title,
          percentage,
          fixed,
          categoryId,
        };
      });
    },
    doctorPieceworkExclusionRows() {
      return this
        .doctorServicesByPriceList
        .flatMap(({ services, title }) => {
          if (title === this.selectedDoctorExclusionCategory) {
            return services;
          }
          return [];
        })
        .map((service, index) => {
          const makeRow = makeMakeExclusionRow(index, service.title, service.value);
          const selection = this
            .selectedDoctorExclusions
            .find((item) => service.value === item.value);
          if (selection) {
            return makeRow(
              true,
              selection.isAssignedManually,
              selection.percentage,
              selection.fixed,
              selection.categoryId,
            );
          }
          return makeRow(
            false,
            false,
            0,
            0,
            service.category_id,
          );
        });
    },
    doctorInitiallyCheckedExclusionIds() {
      return this
        .doctorServicesByPriceList
        .flatMap(({ services }) => services)
        .flatMap(({ checked, value }) => (checked ? [value] : []));
    },
    doctorRemovedExclusionServiceIds() {
      return this.doctorInitiallyCheckedExclusionIds.filter(
        (value) => this
          .selectedDoctorExclusions
          .findIndex((item) => value === item.value) === -1,
      );
    },
  },
  data() {
    return {
      initialDoctorSettings: new DoctorPayrollSettings(),
      isAwaitDoctorPayrollSettingsSave: false,
      doctorExclusionsTableUpdateKey: 0,
      doctorName: '',
      doctorPieceworkDefaultPercentage: 0,
      doctorRole: '',
      doctorSalaryRateRoubles: 0,
      doctorSalaryTypes: [],
      doctorServicesByPriceList: [],
      selectedDoctorExclusionCategory: '',
      selectedDoctorExclusions: [],
      selectedDoctorSalaryType: '',
      doctorSelectedCategory: [],
      doctorPieceworkWithoutDiscounts: false,
      doctorPieceworkWithComplaint: false,
      timerId: null,
      /**
       * @description Прайс листы
       * @type {PriceList}
       */
      priceLists: [],
      /**
       * @description Id выбранного прайс-листа
       * @type {Number|null}
       */
      selectedPriceListId: null,
    };
  },
  methods: {
    /**
     * @description Добавить исключение для сдельной оплаты.
     * @param {number} percentage
     * @param {number} fixed
     * @param {number} value
     * @param {number} categoryId
     * @returns {void}
     */
    addDoctorSelectedExclusion(value, categoryId, percentage = 0, fixed = 0) {
      const updatedExclusions = this
        .selectedDoctorExclusions
        .filter((item) => value !== item.value);
      if (percentage !== 0 || fixed !== 0) {
        updatedExclusions.push(makeDoctorExclusion(false, percentage, value, categoryId, fixed));
      }
      this.selectedDoctorExclusions = updatedExclusions;
      this.checkChanges();
    },
    /**
     * @description Добавить исключение для сдельной оплаты всех услуг категории.
     * @param {number} value
     * @param {number} percentage
     * @param {number} fixed
     */
    addDoctorSelectedExclusionAllServiceCategory(value, percentage = 0, fixed = 0) {
      this
        .doctorServicesByPriceList
        .flatMap(({ services, category_id: categoryId }) => {
          if (categoryId === value) {
            return services;
          }
          return [];
        })
        .forEach((service) => {
          this.addDoctorSelectedExclusion(service.value, value, percentage, fixed);
        });
    },
    /**
     * @description Добавить в выбранные категорию.
     * @param {number} value
     * @param {number} percentage
     * @param {number} fixed
     */
    addDoctorSelectedCategory(value, percentage = 0, fixed = 0) {
      const categories = this
        .doctorSelectedCategory
        .filter((item) => value !== item.value);
      categories.push(makeSelectedCategory(value, percentage, fixed));
      this.doctorSelectedCategory = categories;
    },
    /**
     * @description Проверить наличие изменений настроек доктора.
     * @return {boolean}
     */
    checkDoctorChanges() {
      const actualSettings = this.makeDoctorSettings();
      return actualSettings.toString() !== this.initialDoctorSettings.initial;
    },
    /**
     * @description Получить настройки расчета врача.
     *
     * @param {string} employeeId                Идентификатор сотрудника
     * @param {string|null} selectedPriceListId  Выбранный прайс-лист
     * @param {boolean} byDefaultPriceList       Искать по прайс-листу по умолчанию
     * @return {Promise}
     */
    fetchDoctorSettings(employeeId, selectedPriceListId = null, byDefaultPriceList = false) {
      return this
        .$payrollGateway
        .viewDoctorPayrollSettings(employeeId, selectedPriceListId, byDefaultPriceList)
        .then((result) => {
          result.forEach(({
            employee_name: doctorName,
            employee_role: doctorRole,
            piecework_default_percentage: doctorPieceworkDefaultPercentage,
            salary_rate_roubles: doctorSalaryRateRoubles,
            salary_types: doctorSalaryTypes,
            services_by_price_list: doctorServicesByPriceList,
            piecework_with_complaint: doctorPieceworkWithComplaint,
            piecework_without_discounts: doctorPieceworkWithoutDiscounts,
          }) => {
            this.doctorName = doctorName;
            this.doctorPieceworkDefaultPercentage = doctorPieceworkDefaultPercentage;
            this.doctorRole = doctorRole;
            this.doctorSalaryRateRoubles = doctorSalaryRateRoubles;
            this.doctorSalaryTypes = doctorSalaryTypes;
            this.doctorServicesByPriceList = doctorServicesByPriceList;
            this.doctorPieceworkWithoutDiscounts = doctorPieceworkWithoutDiscounts;
            this.doctorPieceworkWithComplaint = doctorPieceworkWithComplaint;
          });
          return result.isLeft() ? Promise.reject() : Promise.resolve();
        });
    },
    /**
     * @description Форсировать обновление таблицы исключений врача.
     * @returns {void}
     */
    forceDoctorExclusionsTableUpdate() {
      this.doctorExclusionsTableUpdateKey += 1;
      this.$nextTick(() => {
        if (this.focusedInputKey !== null) {
          const focusedInput = this.$refs[this.focusedInputKey][0].$el.querySelector('input');
          if (focusedInput) {
            focusedInput.focus();
          }
        }
      });
    },
    /**
     * @description Проинициализировать данные настроек врача.
     * @returns {void}
     */
    initDoctorData() {
      this.selectedDoctorSalaryType = this
        .doctorSalaryTypes
        .flatMap(({ checked, value }) => (checked ? [value] : []))
        .at(0);
      this.selectedDoctorExclusions = this
        .doctorServicesByPriceList
        .flatMap(({ services }) => services)
        .flatMap(({
          checked,
          is_assigned_manually: isAssignedManually,
          percentage,
          value,
          category_id: categoryId,
          fixed,
        }) => {
          if (checked) {
            return [makeDoctorExclusion(isAssignedManually, percentage, value, categoryId, fixed)];
          }
          return [];
        });
      this.doctorSelectedCategory = this
        .doctorServicesByPriceList
        .map(
          ({ category_id: categoryId, fixed, percentage }) => (
            makeSelectedCategory(categoryId, percentage, fixed)
          ),
        );
      this.initialDoctorSettings = this.makeDoctorSettings();
    },
    /**
     * @description Создать экземпляр настроек доктора.
     * @return {DoctorPayrollSettings}
     */
    makeDoctorSettings() {
      return new DoctorPayrollSettings(
        this.doctorName,
        this.doctorRole,
        this.doctorPieceworkDefaultPercentage,
        this.doctorSalaryRateRoubles,
        this.selectedDoctorExclusions,
        this.selectedDoctorSalaryType,
      );
    },
    /**
     * @description Обработать ввод процентов исключения сервиса сдельной оплаты.
     * @param {number} categoryId
     * @param {number} serviceId
     * @param {number} percentage
     * @returns {void}
     */
    onInputDoctorExclusionServicePercentage(categoryId, serviceId, percentage) {
      this.addDoctorSelectedCategory(categoryId, 0, 0);
      this.addDoctorSelectedExclusion(serviceId, categoryId, percentage);
      this.selectedDoctorExclusions = this.selectedDoctorExclusions.map((item) => {
        if (serviceId === item.value) {
          return makeDoctorExclusion(true, percentage, serviceId, categoryId, 0);
        }
        return item;
      });
      this.checkChanges();
      this.forceDoctorExclusionsTableUpdate();
    },
    /**
     * @description Обработать ввод фиксированной суммы исключения сервиса сдельной оплаты.
     * @param {number} categoryId
     * @param {number} serviceId
     * @param {number} fixed
     * @returns {void}
     */
    onInputDoctorExclusionServiceFixed(categoryId, serviceId, fixed) {
      this.addDoctorSelectedCategory(categoryId, 0, 0);
      this.addDoctorSelectedExclusion(serviceId, categoryId, 0, fixed);
      this.selectedDoctorExclusions = this.selectedDoctorExclusions.map((item) => {
        if (serviceId === item.value) {
          return makeDoctorExclusion(true, 0, serviceId, categoryId, fixed);
        }
        return item;
      });
      this.checkChanges();
      this.forceDoctorExclusionsTableUpdate();
    },
    /**
     * @description Обработать ввод процентов исключения категории сдельной оплаты.
     * @param {number} categoryId
     * @param {number} percentage
     * @returns {void}
     */
    onInputDoctorExclusionCategoryPercentage(categoryId, percentage) {
      this.addDoctorSelectedCategory(categoryId, percentage);
      this.addDoctorSelectedExclusionAllServiceCategory(categoryId, percentage);
      this.checkChanges();
      this.forceDoctorExclusionsTableUpdate();
    },
    /**
     * @description Обработать ввод фиксированной суммы исключения категории сдельной оплаты.
     * @param {number} categoryId
     * @param {number} fixed
     * @returns {void}
     */
    onInputDoctorExclusionCategoryFixed(categoryId, fixed) {
      this.addDoctorSelectedCategory(categoryId, 0, fixed);
      this.addDoctorSelectedExclusionAllServiceCategory(categoryId, 0, fixed);
      this.checkChanges();
      this.forceDoctorExclusionsTableUpdate();
    },
    /**
     * @description Обработать выбор категории исключений.
     * @param {string} value
     * @returns {void}
     */
    onSelectExclusionCategory(evt, value) {
      if (this.selectedDoctorExclusionCategory === value) {
        this.selectedDoctorExclusionCategory = '';
        evt.target.classList.remove('active');
      } else {
        this.selectedDoctorExclusionCategory = value;
        evt.target.classList.add('active');
      }
    },
    /**
     * @description Обработать отправку данных врача.
     * @param {string} employeeId Идентификатор сотрудника.
     * @returns {Promise}
     */
    submitDoctorPayrollSettings(employeeId) {
      this.isAwaitDoctorPayrollSettingsSave = true;
      const response = this
        .$payrollGateway
        .editDoctorPayrollSettings(
          employeeId,
          this.doctorPieceworkDefaultPercentage,
          this.selectedDoctorExclusions,
          this.doctorRemovedExclusionServiceIds,
          this.doctorSalaryRateRoubles,
          this.selectedDoctorSalaryType,
          this.doctorSelectedCategory,
          this.doctorPieceworkWithComplaint,
          this.doctorPieceworkWithoutDiscounts,
        );
      response
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.isChanged = false;
            this.initialDoctorSettings = this.makeDoctorSettings();
          });
        })
        .finally(() => { this.isAwaitDoctorPayrollSettingsSave = false; });
      return response;
    },
  },
  watch: {
    selectedPriceListId(value) {
      if (this.hasFetchedDoctorSettings) {
        this.fetchDoctorSettings(this.employeeId, value, this.selectedDefaultPriceList).then(
          () => {
            this.initDoctorData();
          },
          () => {},
        );
      }
      if (this.hasFetchedAssistantSettings) {
        this.fetchAssistantSettings(this.employeeId, value, this.selectedDefaultPriceList).then(
          () => {
            this.initAssistantData();
          },
          () => {},
        );
      }
    },
  },
  helpTextSalary,
  helpTextServicePercent,
  mixins: [notifierMixin],
};

/**
 * @description Страница схемы расчета ЗП.
 * @type {Vue}
 */
export default {
  computed: {
    needPreventLeave() {
      return this.isChanged;
    },
  },
  components: {
    ItemEmployee,
    HelpIcon,
    ModalDialogPreventLeave,
    InputNumber,
    InputRadio,
    EmployeeProfile,
  },
  created() {
    this
      .fetchAdminSettings(this.employeeId)
      .then(
        () => {
          this.initAdminData();
          this.name = this.adminName;
          this.role = this.adminRole;
          this.hasFetchedAdminSettings = true;
          this.fetchPriceLists();
        },
        () => {},
      );
    this
      .fetchDoctorSettings(this.employeeId, this.selectedPriceListId, this.selectedDefaultPriceList)
      .then(
        () => {
          this.initDoctorData();
          this.name = this.doctorName;
          this.role = this.doctorRole;
          this.hasFetchedDoctorSettings = true;
          this.fetchPriceLists();
        },
        () => {},
      );
    this
      .fetchAssistantSettings(
        this.employeeId,
        this.selectedPriceListId,
        this.selectedDefaultPriceList,
      )
      .then(
        () => {
          this.initAssistantData();
          this.name = this.assistantName;
          this.role = this.assistantRole;
          this.hasFetchedAssistantSettings = true;
          this.fetchPriceLists();
        },
        () => {},
      );
  },
  data() {
    return {
      hasFetchedAdminSettings: false,
      hasFetchedDoctorSettings: false,
      hasFetchedAssistantSettings: false,
      name: '',
      role: '',
      isChanged: false,
      focusedInputKey: null,
    };
  },
  methods: {
    setFocusedInput(key) {
      this.focusedInputKey = key;
    },
    /**
     * @description Обработать отправку данных настроек.
     * @returns {void}
     */
    onSubmit() {
      if (this.hasFetchedAdminSettings) {
        this.submitAdminPayrollSettings(this.employeeId);
      }
      if (this.hasFetchedDoctorSettings) {
        this.submitDoctorPayrollSettings(this.employeeId);
      }
      if (this.hasFetchedAssistantSettings) {
        this.submitAssistantPayrollSettings(this.employeeId);
      }
    },
    async saveAndLeave() {
      let result = null;
      if (this.hasFetchedAdminSettings) {
        result = await this.submitAdminPayrollSettings(this.employeeId);
      }
      if (this.hasFetchedDoctorSettings) {
        result = await this.submitDoctorPayrollSettings(this.employeeId);
      }
      if (this.hasFetchedAssistantSettings) {
        result = await this.submitAssistantPayrollSettings(this.employeeId);
      }
      if (result === null) {
        this.notifyFail('Не удалось сохранить');
        this.isChanged = false;
      } else {
        result.forEach(({ title }) => {
          this.notifySuccess(title);
          this.actionAfterClosingDialogLeaveConfirm();
        });
      }
      this.isShownDialogLeaveConfirm = false;
    },
    /**
     * @description Проверить наличие изменений.
     * @returns {void}
     */
    checkChanges: debounce(function _() {
      this.isChanged = this.checkAdminChanges()
        || this.checkDoctorChanges()
        || this.checkAssistantChanges();
    }, 300),
  },
  mixins: [
    adminSettingsMixin,
    assistantSettingsMixin,
    doctorSettingsMixin,
    preventLeaveWithoutConfirmMixin,
  ],
  name: 'ClinicPanelEmployeePayrollSchema',
  props: {
    /**
     * @description Идентификатор сотрудника.
     */
    employeeId: {
      required: true,
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";
.employee-payroll-schema {
  width: 100%;
  overflow: scroll;
  padding: 38px 20px 48px 23px;
  &__fieldset {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    background: #F2F5F8;
    padding: 22px 26px 24px 30px;
    border: none;
    margin: 0 0 10px 0;
    &__title {
      color: #192A3E;
      font-size: 22px;
      font-weight: 600;
      line-height: normal;
      display: flex;
      align-items: center;
    }
    &__row {
      display: flex;
      flex-flow: row wrap;
      gap: 20px 70px;
      &__group & {
        align-items: center;
      }
    }
    &__group {
      display: flex;
      align-items: center;
      gap: 14px;
      &.group-column {
        flex-direction: column;
        align-items: flex-start;
      }
    }
    &__select-price-list {
      display: flex;
      width: 44%;
      align-items: center;
      gap: 14px;
      &.group-column {
        flex-direction: column;
        align-items: flex-start;
      }
    }
    .group-column {
      &__switch-wrapper {
        display: flex;
        align-items: center;
        column-gap: 10px;
      }
    }
    &__group-stake-doctor {
      display: grid;
      grid-template-columns: minmax(70px, 300px) auto 10px;
      align-items: center;
      grid-gap: 20px;
    }
    &__label {
      color: #192A3E;
      font-size: 16px;
      font-weight: 500;
      min-width: fit-content;
    }
    &__button-add {
      color: #0489e0;
    }
    &__button-remove {
      color: #ff0000;
    }
    .payroll-table-head {
      margin-top: 20px;
      border-bottom: 2px solid #0489e0;
      &__title {
        font-weight: 600;
        &--info {
          display: flex;
          align-items: center;
          column-gap: 5px;
        }
      }
    }
  }
  &__exclusion {
    display: grid;
    grid-template-columns:
      minmax(300px, 400px)
      minmax(295px, 326px)
      minmax(200px, auto);
    align-items: center;
    grid-gap: 90px;
    margin-top: 20px;
    min-width: 1100px;
    @media screen and (max-width: 1120px) {
      grid-gap: 60px;
    }
  }
  &__category {
    display: flex;
    flex-direction: column;
    &__caption {
      border-bottom: 2px solid var(--action-color);
      color: #323C47;
      font-size: 14px;
      font-weight: 700;
      line-height: normal;
      padding: 10px 8px;
    }
    &__cell {
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      justify-self: self-start;
      max-width: 400px;
      width: 100%;
      padding: 10px 0;
      color: rgba(0, 0, 0, 0.87);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-align: left;
      &:not(.cell-child)::after {
        content: '';
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        background: url("@/assets/img/arrow/chevron-down.svg") no-repeat right center;
        background-size: 16px 16px;
        transition: transform 0.3s;
      }
      &.active:focus::after {
        transform: rotate(180deg);
      }
      &.selected {
        color: #0489E0;
        font-weight: 700;
      }
    }
    &__cell.cell-child {
        font-weight: 400;
    }
  }
  &__input {
    max-width: 180px;
    min-width: 90px;
  }
  &__table {
    display: flex;
    flex-direction: column;
    counter-reset: counterEmployees;
    .employee-payroll-schema__table__body-row:last-child {
      border: none;
    }
    &__head,
    &__body-row {
      display: grid;
      grid-template-columns: 40px 40px 1fr 150px;
      align-items: center;
      div {
        position: relative;
        padding: 10px 8px;
      }
    }
    &__head {
      border-bottom: 2px solid var(--action-color);
      div {
        color: #323C47;
        font-size: 14px;
        font-weight: 700;
        line-height: normal;
      }
    }
    &__body-row {
      background: var(--primary-background-color);
      border-bottom: 1px solid  #EAEFF3;
    }
    &__body-row.assigned-manually {
      font-weight: 500;
    }
  }
  &__submit {
    @include buttons.btn-blue(250px, 50px, 16px);
    margin: 30px 0 0 0;
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
}
@media screen and (max-width: 1280px) {
  .employee-payroll-schema__exclusion-wrapper {
    overflow-x: scroll;
  }
}
@media screen and (max-width: 600px) {
  .employee-payroll-schema {
    &__fieldset {
      padding: 22px 10px 24px;
    }
  }
}
@media screen and (max-width: 480px) {
  .employee-payroll-schema {
    padding: 38px 10px 48px;
    &__form {
      .stake-doctor__group-input {
        flex-wrap: wrap;
      }
    }
    &__table {
      &__head {
        display: none;
      }
      &__body-row {
        grid-template-columns: 1fr;
        div {
          display: flex;
          justify-content: space-between;
        }
        div:before {
          content: attr(data-label);
          font-weight: 700;
          margin-right: 20px;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
